<div class="row">
  <div class="col-md-12">

    <div class="tile">

      <section class="invoice">
        <div class="row mb-4">
          <div class="col-12">
            <h2 class="preview-page-header"><i class="fa fa-file-text-o"></i> Data Verification & Submission</h2>
          </div>

        </div>


        <div class="row" *ngIf="!isPostgraduateStudent()">
          <div class="col-md-12">
            <div class="post-content">
              <p class="note-text" *ngIf="!isForignStudent()">NOTE: YOUR APPLICATION IS INCOMPLETE IF YOU DO NOT ADD
                YOUR RESULTS.
                ALL AWAITING STUDENTS SHOULD UPDATE THEIR APPLICATION WITH THEIR RESULTS WHEN RELEASED.
                <br>
                Please Provide Your Name And Any Other Information Exactly As It Appears On Your Examination Results
                Slip<br>
                (NB: All Fields marked must be filled)
              </p>

              <p class="note-text" *ngIf="isForignStudent()">NOTE: YOUR APPLICATION IS INCOMPLETE IF YOU DO NOT UPLOAD
                YOUR RESULTS.
                ALL AWAITING STUDENTS SHOULD UPDATE THEIR APPLICATION WITH THEIR RESULTS WHEN RELEASED.
                <br>
                Please Provide Your Name And Any Other Information Exactly As It Appears On Your Examination Results
                Slip<br>
                (NB: All Fields marked must be filled)
              </p>

            </div>




          </div>

        </div>



        <div class="row" *ngIf="isPostgraduateStudent()">
          <div class="col-md-12">
            <div class="post-content">
              <p class="note-text" *ngIf="!isForignStudent()">NOTE: THE COMPLETED ONLINE APPLICATION FORM SHOULD BE
                PRINTED AND SUBMITTED WITH THE RELEVANT DOCUMENTS, INCLUDING CERTIFICATES AND TRANSCRIPTS OBTAINED AT
                THE MASTER'S, BACHELOR'S AND SENIOR HIGH SCHOOL LEVELS OR THEIR EQUIVALENTS WHEREVER APPLICABLE, TO THE
                ADDRESS.
                <br>
                Please Provide Your Name And Any Other Information Exactly As It Appears On Your Examination Results
                Slip<br>
                (NB: All Fields marked must be filled)
              </p>

              <p class="note-text" *ngIf="isForignStudent()">NOTE: YOUR APPLICATION IS INCOMPLETE IF YOU DO NOT UPLOAD
                YOUR RESULTS.
                ALL AWAITING STUDENTS SHOULD UPDATE THEIR APPLICATION WITH THEIR RESULTS WHEN RELEASED.
                <br>
                Please Provide Your Name And Any Other Information Exactly As It Appears On Your Examination Results
                Slip<br>
                (NB: All Fields marked must be filled)
              </p>

            </div>




          </div>

        </div>






        <div class="row">
          <div class="col-12 table-responsive">
            <table class="applicant-info-table">
              <tbody>
                <tr class="sub-header-margin-top">
                  <td colspan="4"></td>
                </tr>

                <tr class="sub-headers">
                  <td colspan="2"> Personal Information</td>
                  <td colspan="2" class="ref-id">Serial No: {{applicantData.StudentNumber}}</td>
                </tr>
                <tr class="sub-header-margin-buttom">
                  <td colspan="4"></td>
                </tr>

                <tr>
                  <td class="td-label-right">Surname:</td>
                  <td class="td-label-left">{{applicantData.LastName}}</td>
                  <td rowspan="8" colspan="2">
                    <img class="user-pic" src="{{applicantData.PhotoUrl}}" alt="">
                  </td>
                </tr>
                <tr>
                  <td class="td-label-right">First Names:</td>
                  <td colspan="2" class="td-label-left">{{applicantData.FirstName}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Middle Name(s):</td>
                  <td colspan="2" class="td-label-left">{{applicantData.OtherName}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Sex:</td>
                  <td colspan="2" class="td-label-left">{{applicantData.GenderName}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Date of Birth:</td>
                  <td colspan="2" class="td-label-left">{{applicantData.DateOfBirth|date}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Home Town:</td>
                  <td colspan="2" class="td-label-left">{{applicantData.HomeTown}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Country of Origin:</td>
                  <td colspan="2" class="td-label-left">{{applicantData.Country}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Denomination:</td>
                  <td colspan="3" class="td-label-left">{{applicantData.Religion}}</td>
                </tr>

                <tr *ngIf="invalidPersonalInfo">
                  <td colspan="4">
                    <h3 class="text-center text-danger">**Personal Information not complete**</h3>
                  </td>
                </tr>
                <!-- Contact Information Start -->


                <tr class="sub-header-margin-top">
                  <td colspan="4"></td>
                </tr>

                <tr class="sub-headers contact-header">
                  <td colspan="4"> Contact Information</td>
                </tr>
                <tr class="sub-header-margin-buttom">
                  <td colspan="4"></td>
                </tr>

                <tr>
                  <td class="td-label-right">Postal Address:</td>
                  <td class="td-label-left">{{applicantData.AddressLine1}}</td>
                  <td class="td-label-right">Email Address:</td>
                  <td class="td-label-left">{{applicantData.Email}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Residential Address:</td>
                  <td class="td-label-left">{{applicantData.ResidentialAddress1}}</td>
                  <td class="td-label-right">Fax No.:</td>
                  <td class="td-label-left">{{applicantData.FaxNumber}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">City / Town: </td>
                  <td class="td-label-left">{{applicantData.City}}</td>
                  <td class="td-label-right">Mobile No.:</td>
                  <td class="td-label-left">{{applicantData.PrimaryNumber}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Region:</td>
                  <td class="td-label-left">{{applicantData.Region}}</td>

                </tr>
                <tr *ngIf="invalidContactInfo">
                  <td colspan="4">
                    <h3 class="text-center text-danger">**Contact Information not complete**</h3>
                  </td>
                </tr>


                <tr class="sub-header-margin-top">
                  <td colspan="4"></td>
                </tr>

                <tr>
                  <td colspan="4" class="sub-headers contact"> Parent's / Guardian's Information<br></td>
                </tr>
                <tr class="sub-header-margin-buttom">
                  <td colspan="4"></td>
                </tr>

                <tr>
                  <td class="td-label-right"> Guardian Name:</td>
                  <td class="td-label-left">{{guardianData.Name}}</td>
                  <td class="td-label-right">Relationship To Applicant:</td>
                  <td class="td-label-left">{{guardianData.RelationshipToStudent}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Postal Address:</td>
                  <td class="td-label-left">{{guardianData.AddressLine1}}</td>
                  <td class="td-label-right">Email Address:</td>
                  <td class="td-label-left">{{guardianData.Email}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Residential Address:</td>
                  <td class="td-label-left">{{guardianData.ResidentialAddress1}}</td>
                  <td class="td-label-right">Occupation:</td>
                  <td class="td-label-left">{{guardianData.Occupation}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">City / Town: </td>
                  <td class="td-label-left">{{guardianData.City}}</td>
                  <td class="td-label-right">University Staff Position</td>
                  <td class="td-label-left">{{guardianData.StaffPosition}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Region:</td>
                  <td class="td-label-left">{{guardianData.RegionName}}</td>
                  <td class="td-label-right"></td>
                  <td class="td-label-left"></td>
                </tr>
                <tr>
                  <td class="td-label-right">Telephone No:</td>
                  <td class="td-label-left">{{guardianData.PrimaryNumber}}</td>
                  <td class="td-label-right">Fax No:</td>
                  <td class="td-label-left"></td>
                </tr>

                <tr *ngIf="invalidGuardianInfo">
                  <td colspan="4">
                    <h3 class="text-center text-danger">**Guardian's Information not complete**</h3>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>

        </div>








        <div class="sub-header-margin-top"></div>


        <div class="sub-headers-v2" *ngIf="!isPostgraduateStudent()">
          <h6>Choice Of Programmes</h6>
        </div>

        <div class="row" *ngIf="!isPostgraduateStudent()">
          <div class="col-12 table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Choice</th>
                  <th>Selected Programme</th>
                  <th>Fees Status</th>
                </tr>
              </thead>
              <tbody *ngIf="applicantProgrammeOfChoices">
                <tr *ngFor="let item of applicantProgrammeOfChoices; let i=index">
                  <td>{{getProgrammeChoiceName(item.ChoiceIndex)}}</td>
                  <td>{{item.Programme.FullName}}</td>
                  <td>{{item.ProgrammeFundingId=='R'?'Regular':'Fee Paying'}}</td>

                </tr>

                <tr *ngIf="!applicantProgrammeOfChoices">
                  <td colspan="3">
                    <h3 class="text-center text-danger">**Choice of programme is not provided**</h3>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>

        <div class="sub-header-margin-top"></div>


        <div class="row" *ngIf="!isPostgraduateStudent()">
          <div class="col-12 table-responsive">
            <div *ngFor="let header of examinationData; let i=index">


              <table class="applicant-info-table" *ngFor="let item of getExamItem(header)">

                <tr>
                  <td colspan="4" class="sub-headers contact">{{i+1}} Examination Information<br></td>
                </tr>
                <tr class="sub-header-margin-buttom">
                  <td colspan="4"></td>
                </tr>

                <tr>
                  <td class="td-label-right"> Name Of School:</td>
                  <td class="td-label-left">{{item.Institution}}</td>
                  <td class="td-label-right">School Code:</td>
                  <td class="td-label-left">{{item.SchoolCode}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Centre:</td>
                  <td class="td-label-left">{{item.ExaminationCentre}}</td>
                  <td class="td-label-right">Region:</td>
                  <td class="td-label-left">{{item.Region}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Application Type:</td>
                  <td class="td-label-left">{{item.ApplicationMode}}</td>
                  <td class="td-label-right">Index Number:</td>
                  <td class="td-label-left">{{item.ExamIndexNumber}}</td>
                </tr>
                <tr>
                  <td class="td-label-right">Year Of Sitting: </td>
                  <td class="td-label-left">{{item.YearOfExamSitting}}</td>
                  <td class="td-label-right">Period Of Setting</td>
                  <td class="td-label-left">{{item.ExamPeriod}}</td>
                </tr>


                <tr>
                  <td colspan="4">
                    <div>
                      <div class="sub-header-margin-top"></div>
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>Course</th>
                            <th>Grade</th>
                            <th>Type</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let data of getValidExamItems(header.Items)">
                            <td>{{data.ApplicantCourse}}</td>
                            <td>{{data.ApplicantCourseGradeTypeItem}}</td>
                            <td>{{data.ApplicantCourseCategory}}</td>
                          </tr>

                          <tr *ngIf="!getValidExamItems(header.Items).length">
                            <td colspan="3">
                              <h3 class="text-center text-danger">**Grades is not provided for Examination**</h3>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </td>



                </tr>


              </table>


            </div>
          </div>
        </div>



        <div class="row">
          <div class="col-md-12">
            <h3 class="text-center">All other information provided will be displayed on the printout page.</h3>
          </div>

        </div>

        <!-- this row will not appear when printing -->
        <hr>
        <div class="row no-print">
          <div class="col-lg-3">
            <button (click)="onPrint()" class="btn btn-outline-secondary m-1">
              <i class="fa fa-print"></i> Submit &amp; Print
            </button>
            <!-- <a href="javascript:window.print();" target="_blank" class="btn btn-outline-secondary m-1">
                    <i class="fa fa-print"></i> Print</a> -->
          </div>
          <div class="col-lg-9">
            <div class="float-sm-right">
              <button class="btn btn-default waves-effect waves-light m-1" (click)="goToPrevious()"><i
                  class="fa fa-backward"></i> Go Back &amp; Make Changes</button>
              <!-- <button class="btn btn-danger waves-effect waves-light m-1" (click)="onSubmit()"><i class="fa fa-credit-card"></i> Submit Forms</button> -->
            </div>
          </div>
        </div>



      </section>


    </div>

  </div>
</div>